import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.yml";
import fr from "./fr.yml";
import getUrlParameters from "../utils/getUrlParameters";

const supportedLanguages = ["en", "fr"];

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        fr: { translation: fr },
    },
    lng: document.documentElement.lang,
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    fallbackLng: "en",
});

const debugLanguage = getUrlParameters().dlang || document.documentElement.lang;
if (supportedLanguages.includes(debugLanguage)) {
    i18n.changeLanguage(debugLanguage);
}

export default i18n;
